
// react
import React from "react";
// router
import Router from "./layouts/router/router.tsx";

const App = () => {
    return (
        <>
            {/* content */}
            <Router />
        </>
    );
}

export default App;
